// "use client"; // Uncomment if using Next.js App Router

import React, { useState } from "react";
import "./FaqSection.css";
import { Header } from "../PageTemplate/Header";

const defaultFaqs = [
	{
		question: "What is VerifyTT?",
		answer: "VerifyTT is a national digital platform that enables organisations to issue, store, and verify credentials securely in real time, reducing reliance on paper-based processes.",
	},
	{
		question: "Is VerifyTT just for academic certificates?",
		answer: "No. While it starts with education, VerifyTT supports credentials across:\n    i. Government agencies;\n\nii. Private sector organizations;\n\niii. Employers;",
	},
	{
		question: "Who can use VerifyTT?",
		answer: "Government agencies, educational institutions, private sector organisations, regulators, employers and citizens.",
	},
	{
		question: "Is this only for the Government?",
		answer: "No. While it is a national platform, VerifyTT is designed for both public and private sector participation, enabling a shared trust ecosystem.",
	},

	{
		question: "Why is VerifyTT being introduced?",
		answer: "As a modern alternative to slow, manual verification processes through instant, secure, and trusted digital verification.",
	},
	{
		question: "What problems will VerifyTT solve?",
		answer: "It reduces fraud; speeds up verification; lowers costs to both institutions and citizens while building trust across sectors.",
	},
	{
		question: "How are verifiable credentials different from a PDF?",
		answer: "i. A PDF by itself is not verifiable.\n\nii. Anyone can create a PDF. However only issuers / issuing agencies can generate verifiable credentials on this platform.",
	},
	{
		question: "What can VerifyTT be used for?",
		answer: "VerifyTT can be used for any type of legal instrument and official verifiable documentation. (e.g. Educational Certificates and Transcripts; Legal Instruments; and other official documents)",
	},
	{
		question: "Can VerifyTT integrate with existing systems?",
		answer: "Yes. VerifyTT is designed to integrate with existing systems, enabling seamless adoption.",
	},
	{
		question: "Are VerifyTT credentials legally recognised?",
		answer: "Yes.",
	},
	{
		question: "Can VerifyTT scale for national-level usage?",
		answer: "Yes. The platform is designed to support high-volume issuance and verification across multiple sectors.",
	},
	{
		question: "How can my organization get started?",
		answer: "Organizations can begin by:\n    i. Booking a Consultation with our Business Development Unit\n    ii. Contacting Us: GovTT-Consulting-BusinessDevelopment@gov.tt",
	},
	{
		question: "How long does implementation take?",
		answer: "Implementation timelines depend on the complexity of the use case, but onboarding and/or a pilot can be initiated within a short timeframe.",
	},
];

const FaqSection = ({
	faqs = defaultFaqs,
	title = "Frequently Asked Questions",
}) => {
	const [openIndex, setOpenIndex] = useState(0);

	const handleToggleFaq = (index) => {
		setOpenIndex((prev) => (prev === index ? null : index));
	};

	const handleFaqKeyDown = (event, index) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			handleToggleFaq(index);
		}
	};

	return (
		<div className="page-root">
			{/* HEADER */}
			<Header />

			{/* MAIN FAQ SECTION */}
			<main className="faq-section">
				<div className="faq-blob" />
				<div className="faq-inner">
					<h1 className="faq-heading">{title}</h1>

					{faqs.map((item, index) => {
						const isOpen = openIndex === index;
						const cardClasses = ["faq-card"];
						if (index > 0) cardClasses.push("faq-card--compact");
						if (isOpen) cardClasses.push("faq-card--open");

						return (
							<div
								key={item.question}
								className={cardClasses.join(" ")}
								onClick={() => handleToggleFaq(index)}
								role="button"
								tabIndex={0}
								onKeyDown={(e) => handleFaqKeyDown(e, index)}
								aria-expanded={isOpen}
							>
								<div className="faq-question-row">
									<div
										className={
											isOpen
												? "faq-question-indicator"
												: "faq-question-indicator--plus"
										}
									/>
									<div className="faq-question-text">
										{item.question}
									</div>
								</div>

								<div
									className={
										"faq-answer " +
										(isOpen
											? "faq-answer--open"
											: "faq-answer--closed")
									}
								>
									{item.answer}
								</div>
							</div>
						);
					})}
				</div>
			</main>
		</div>
	);
};

export default FaqSection;
